customElements.define('product-card', class extends HTMLElement {
  constructor() {
    super();
    this.cacheElements();
    this.addEventListeners();
  }

  cacheElements() {
    this.image = this.querySelector('.product-card__img');
    this.color = this.querySelector('.product-card__color');
    this.variantId = this.querySelector('[variant-ids]');
    this.urls = this.querySelectorAll('.product-card__url');
    this.quickBuyBtn = this.querySelector('.button-quick-buy');
    this.ctaText = this.quickBuyBtn?.querySelector('span');
    this.badge = this.querySelector('.product-badge');
    this.priceBlock = this.querySelector('.price');
    this.priceItemSale = this.querySelector('.price-item--sale');
    this.priceItemRegularSaleContainer = this.querySelector('.price__sale .price-item--regular');
    this.priceItemRegular = this.querySelector('.price__regular .price-item--regular');
  }

  addEventListeners() {
    this.querySelectorAll('.color-swatch')?.forEach(swatch =>
      swatch.addEventListener('click', () => this.onColorClick(swatch))
    );

    ['mouseover', 'touchstart'].forEach(evt =>
      this.addEventListener(evt, e => this.onHover(e))
    );

    ['mouseout', 'touchend'].forEach(evt =>
      this.addEventListener(evt, e => this.onHoverOut(e))
    );
  }

  onHover(event) {
    if (window.innerWidth <= 550) { 
      if (event.target.closest('.button-quick-buy')) return;
    }

    const hoverSrc = this.image?.getAttribute('data-on-hover-src');
    if (hoverSrc) {
      this.image.setAttribute('data-original-src', this.image.src);
      this.image.src = hoverSrc;
      if (this.badge) this.badge.style.display = 'none';
    }
  }

  onHoverOut(event) {
    if (window.innerWidth <= 550) { 
      if (event.target.closest('.button-quick-buy')) return;
    }

    const originalSrc = this.image?.getAttribute('data-original-src');
    if (originalSrc) {
      this.image.src = originalSrc;
      this.image.removeAttribute('data-original-src');
      if (this.badge) this.badge.style.display = '';
    }
  }


  onColorClick(swatch) {
    const {
      productImage,
      productId,
      productColor,
      productAvailable,
      productIsPreOrder,
      productIsAppExclusive,
      productIsBhgNoDiscount,
      productBhgDiscountedPrice,
      productOriginalPrice,
      // DELETE LATER BIS_trigger removed
      // productIsBackInStock, 
      productIsOutOfStock,
      productUrl,
      productImageOnHover,
      productBadgeImg,
      productBadgeBcgColor,
      productBadgeFontColor,
      productBadgeText,
      productBadge
    } = swatch.dataset;

    this.updateSwatchSelection(swatch);
    this.updateImage(productImage, productImageOnHover);
    this.updateColor(productColor);
    this.updateBadge({ productBadgeImg, productBadgeText, productBadge, productBadgeBcgColor, productBadgeFontColor });
    this.updateUrls(productUrl);
    this.updateVariant(productId, productIsAppExclusive);
    this.updateCTA({ productIsPreOrder, productIsOutOfStock, productIsAppExclusive, productUrl });
    this.updatePrice({ productBhgDiscountedPrice, productOriginalPrice, productIsBhgNoDiscount });
  }

  updateSwatchSelection(swatch) {
    const previous = this.querySelector('.color-swatch--selected');
    previous?.classList.remove('color-swatch--selected');
    previous?.setAttribute('aria-pressed', 'false');
    swatch.classList.add('color-swatch--selected');
    swatch.setAttribute('aria-pressed', 'true');
  }

  updateImage(imageSrc, hoverSrc) {
    if (!this.image) return;
    this.image.src = imageSrc;
    this.image.setAttribute('data-original-src', imageSrc);

    if (hoverSrc) {
      this.image.setAttribute('data-on-hover-src', hoverSrc);
    } else {
      this.image.removeAttribute('data-on-hover-src');
    }
  }

  updateColor(colorName) {
    if (this.color) this.color.textContent = colorName;
  }

  updateBadge({ productBadgeImg, productBadgeText, productBadge, productBadgeBcgColor, productBadgeFontColor }) {
    if (!this.badge) return;

    let html = '';
    if (productBadgeImg) {
      html = `<img src="${productBadgeImg}" class="product-badge__img w100" alt="Product Badge" />`;
    } else if (productBadgeText) {
      const bg = productBadgeBcgColor || '#111';
      const fg = productBadgeFontColor || '#fff';
      html = `<div class="flex-center-center center px-05" style="background-color: ${bg};">
        <span class="font-11 bold uppercase" style="color: ${fg};">${productBadgeText}</span>
      </div>`;
    } else if (productBadge) {
      html = `<div class="product-badge__tag font-11 bold uppercase">${productBadge}</div>`;
    }

    this.badge.innerHTML = html;
  }

  updateUrls(url) {
    this.urls.forEach(link => link.href = url);
  }

  updateVariant(variantId, isExclusive) {
    if (this.variantId) {
      if (isExclusive) {
        this.variantId.setAttribute('variant-ids', '');
      } else {
        this.variantId.setAttribute('variant-ids', variantId);
      }
    }
  }

  updateCTA({ productIsPreOrder, productIsOutOfStock, productIsAppExclusive, productUrl }) {
    if (!this.quickBuyBtn || !this.ctaText) return;

    let cta = 'Add to cart';
    const btn = this.quickBuyBtn;
    btn.classList.remove('button-quick-buy__pre-order', 'button-oos', 'unavailable', 'button-quick-buy__app-exclusive');
    btn.removeAttribute('href');

    if (productIsPreOrder) {
      cta = productIsPreOrder;
      btn.classList.add('button-quick-buy__pre-order');
    } else if (productIsOutOfStock) {
      cta = 'View Product';
      btn.classList.add('button-oos');
      btn.setAttribute('href', productUrl);
    } else if (productIsAppExclusive) {
      cta = productIsAppExclusive;
      btn.classList.add('button-quick-buy__app-exclusive');
    }

    this.ctaText.innerHTML = cta;
    btn.classList.remove('product-added');
  }

  updatePrice({ productBhgDiscountedPrice, productOriginalPrice, productIsBhgNoDiscount }) {
    if (!this.priceBlock) return;

    if (productIsBhgNoDiscount) {
      this.priceBlock.classList.add('price--bhg_no_discount');
    } else {
      this.priceBlock.classList.remove('price--bhg_no_discount');
    }

    if (productBhgDiscountedPrice && this.priceItemSale && this.priceItemRegularSaleContainer) {
      this.priceBlock.classList.add('price--on-sale');
      this.priceBlock.classList.remove('price--bhg_no_discount');
      this.priceItemSale.innerHTML = productBhgDiscountedPrice;
      this.priceItemRegularSaleContainer.innerHTML = productOriginalPrice;
    } else {
      this.priceBlock.classList.remove('price--on-sale');
      this.priceBlock.classList.add('price--bhg_no_discount');
      this.priceItemRegular.innerHTML = productOriginalPrice;
    }
  }
});